import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/Terms.css';

function Terms() {
    const [loading, setLoading] = useState(true);
    const [terms, setTerms] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    
    // Base URL for API calls
    const baseUrl = process.env.REACT_APP_NODE_ENV === 'production' 
        ? process.env.REACT_APP_PRODUCTION_BASE_URL 
        : process.env.REACT_APP_DEVELOPMENT_BASE_URL;



    useEffect(() => {
        const fetchTerms = async () => {
            try {
                const response = await axios.get(`${baseUrl}/api/settings-text`);
                if (response.data.success && response.data.data) {
                    setTerms(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching terms:', error);
                setError('Failed to load terms and conditions');
            } finally {
                setLoading(false);
            }
        };

        fetchTerms();
        
        // Scroll to top on component mount
        window.scrollTo(0, 0);
    }, [baseUrl]);

    const handleBackClick = () => {
        navigate('/');
    };

    return (
        <div className="terms-page">
            <div className="container py-5">
                <div className="back-button" onClick={handleBackClick}>
                    <i className="fas fa-arrow-left"></i> Back to Home
                </div>
                <div className="terms-content">
                    {loading ? (
                        <div className="loading text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3">Loading terms and conditions...</p>
                        </div>
                    ) : error ? (
                        <div className="error">
                            <h2>Error</h2>
                            <p>{error}</p>
                        </div>
                    ) : terms && terms.termsText ? (
                        <div className="content">
                            <h1>Terms & Conditions</h1>
                            <div dangerouslySetInnerHTML={{ __html: terms.termsText }} />
                        </div>
                    ) : (
                        <div className="notice">
                            <h2>Notice</h2>
                            <p>Terms and conditions are currently being updated. Please check back later.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Terms;